import React, { Component } from "react";
import { Button, Alert, Spin } from "antd";
import PropTypes from "prop-types";
import qs from "qs";

import {
  FormContainer,
  Header,
  Footer,
  EmailInstructions,
  EmailVerificationReason,
  ContactUsLink
} from "../../components";
import axios from "axios";

class AccountLocked extends Component {
  state = {
    email: "",
    message: "",
    verification: {
      processing: false,
      error: false,
      errorMsg: "",
      data: null
    }
  };

  componentDidMount() {
    const { location } = this.props;
    const query = qs.parse(location.search.replace("?", "")); //remove ? from start of location.search

    this.setState({
      email: query["email"],
      message: query["message"]
    });
  }

  sendVerificationEmail = () => {
    const { email } = this.state;
    const appsAPI = axios.create({
      baseURL: "https://api.apps.pdview.com.au"
    });
    const self = this;

    self.setState(
      prevState => ({
        verification: {
          ...prevState.verification,
          processing: true
        }
      }),
      () =>
        appsAPI
          .get(`/verifyemailbyemail?email=${email}`)
          .then(function(response) {
            self.setState(prevState => ({
              verification: {
                ...prevState.verification,
                processing: false,
                data: response.data
              }
            }));
          })
          .catch(err => {
            console.log("Error occurred while sending verification email", err);
            self.setState(prevState => ({
              verification: {
                ...prevState.verification,
                processing: false,
                error: true,
                errorMsg: err.message
              }
            }));
          })
    );
  };

  render() {
    const { email, message, verification } = this.state;
    return (
      <div>
        <Header />
        <FormContainer formTitle={"Account locked"}>
          <Alert
            message={"Your account has been locked. Reason: " + message}
            type={"warning"}
            showIcon
          />
          <br />
          <p>Verify your email address to gain access to your account.</p>
          <Spin spinning={verification.processing}>
            <div style={{ textAlign: "center" }}>
              <p>
                <b>Your email address:</b> {email}
              </p>
              <Button
                type={"primary"}
                icon={"mail"}
                onClick={this.sendVerificationEmail}
                style={{ margin: "8px 0" }}
                disabled={verification.data}
              >
                Send verification email
              </Button>
            </div>
          </Spin>
          {verification.error && (
            <Alert type={"warning"} showIcon message={verification.errorMsg} />
          )}
          {verification.data && (
            <Alert type={"success"} showIcon message={<EmailInstructions />} />
          )}

          <EmailVerificationReason
            style={{ textAlign: "right", margin: "8px 0" }}
          />
          <ContactUsLink />
        </FormContainer>
        <Footer />
      </div>
    );
  }
}
AccountLocked.propTypes = {
  location: PropTypes.object.isRequired
};

export default AccountLocked;



// WEBPACK FOOTER //
// ./src/views/account_locked/AccountLocked.jsx